import { useContext } from 'react'
import { AnalyticsHeaderSlotContext } from './AnalyticsHeaderSlotContext'

export function useAnalyticsHeaderSlot() {
    return useContext(AnalyticsHeaderSlotContext)
}
